module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title",
    attrs: {
      "id": "create-account-panel"
    }
  }, [_vm._v("\n        Pas encore inscrit ?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-7 large-centered columns"
  }, [_c('router-link', {
    attrs: {
      "to": "/createaccount"
    }
  }, [_c('button', {
    staticClass: "full-width"
  }, [_vm._v("Je crée un compte")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fb-root"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc04575e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/register-panel.vue
// module id = 808
// module chunks = 0